module.exports = __webpack_public_path__ + "static/media/withoutInvoice.4acc7474.svg";